<div
  class="oiq-ui-dialog absolute bottom-0 left-0 top-0 flex max-h-screen flex-col rounded-none"
  [class]="
    showPngPreview()
      ? 'w-[1186px] min-[1440px]:w-[1286px] xxl:w-[1486px]'
      : 'w-[600px] min-[1440px]:w-[700px] xxl:w-[900px]'
  ">
  <header class="flex-shrink-0 border-b border-gray-4">
    <div class="__title">
      <div>
        @if (data.mode === 'link') {
          <h2>Link documents</h2>
        } @else if (data.mode === 'stipulations') {
          <h2>Associated stipulations</h2>
        } @else {
          <h2>New Application</h2>
        }
      </div>
      <button class="oiq-button oiq-button--link __close" type="button" (click)="cancel()">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </header>
  <div class="flex min-h-0 flex-1 overflow-hidden">
    <main class="flex-1 space-y-4 overflow-y-auto p-4">
      @if (data.mode === 'link') {
        <div class="flex flex-col gap-2">
          <div class="flex items-center gap-2">
            <svg
              width="13"
              height="15"
              viewBox="0 0 13 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.2105 2.97703L9.39797 0.164531C9.34569 0.112312 9.28364 0.0709042 9.21535 0.0426734C9.14707 0.0144426 9.07389 -5.79295e-05 9 1.73924e-07H3.375C3.07663 1.73924e-07 2.79048 0.118527 2.57951 0.329505C2.36853 0.540483 2.25 0.826632 2.25 1.125V2.25H1.125C0.826631 2.25 0.540483 2.36853 0.329505 2.57951C0.118526 2.79048 0 3.07663 0 3.375V13.5C0 13.7984 0.118526 14.0845 0.329505 14.2955C0.540483 14.5065 0.826631 14.625 1.125 14.625H9C9.29837 14.625 9.58452 14.5065 9.79549 14.2955C10.0065 14.0845 10.125 13.7984 10.125 13.5V12.375H11.25C11.5484 12.375 11.8345 12.2565 12.0455 12.0455C12.2565 11.8345 12.375 11.5484 12.375 11.25V3.375C12.3751 3.30111 12.3606 3.22793 12.3323 3.15965C12.3041 3.09136 12.2627 3.02931 12.2105 2.97703ZM9 13.5H1.125V3.375H6.51727L9 5.85773V11.8012C9 11.8055 9 11.809 9 11.8125C9 11.816 9 11.8195 9 11.8238V13.5ZM11.25 11.25H10.125V5.625C10.1251 5.55111 10.1106 5.47793 10.0823 5.40965C10.0541 5.34136 10.0127 5.27931 9.96047 5.22703L7.14797 2.41453C7.09569 2.36231 7.03364 2.3209 6.96535 2.29267C6.89707 2.26444 6.82389 2.24994 6.75 2.25H3.375V1.125H8.76727L11.25 3.60773V11.25ZM7.3125 9C7.3125 9.14918 7.25324 9.29226 7.14775 9.39775C7.04226 9.50324 6.89918 9.5625 6.75 9.5625H3.375C3.22582 9.5625 3.08274 9.50324 2.97725 9.39775C2.87176 9.29226 2.8125 9.14918 2.8125 9C2.8125 8.85082 2.87176 8.70774 2.97725 8.60225C3.08274 8.49676 3.22582 8.4375 3.375 8.4375H6.75C6.89918 8.4375 7.04226 8.49676 7.14775 8.60225C7.25324 8.70774 7.3125 8.85082 7.3125 9ZM7.3125 11.25C7.3125 11.3992 7.25324 11.5423 7.14775 11.6477C7.04226 11.7532 6.89918 11.8125 6.75 11.8125H3.375C3.22582 11.8125 3.08274 11.7532 2.97725 11.6477C2.87176 11.5423 2.8125 11.3992 2.8125 11.25C2.8125 11.1008 2.87176 10.9577 2.97725 10.8523C3.08274 10.7468 3.22582 10.6875 3.375 10.6875H6.75C6.89918 10.6875 7.04226 10.7468 7.14775 10.8523C7.25324 10.9577 7.3125 11.1008 7.3125 11.25Z"
                fill="#606B84" />
            </svg>

            <h2 class="text-[18px] font-medium">Select a Document(s)</h2>
          </div>
          <p class="mb-4">Please select document(s) to link to the application</p>
        </div>

        @if (mappedAttachments().length > 0) {
          <div class="flex flex-col">
            <div class="mb-2 flex items-center justify-between">
              <p class="text-sm font-medium text-gray-2">Email Attachment(s):</p>

              <div class="flex items-center gap-2">
                <oiq-form-checkbox
                  class="p-1"
                  [formControl]="selectAllControl"
                  label="Select All"
                  orientation="right"
                  type="toggle">
                </oiq-form-checkbox>
              </div>
            </div>
            @for (attachment of mappedAttachments(); track attachment.id; let i = $index) {
              <oiq-email-attachment
                [displayMode]="'dialog'"
                [pngPreviewMode]="'new-application'"
                [(attachedStipulations)]="attachedStipulations"
                [emailAttachment]="attachment"
                [emailId]="attachment.emailId || data.emailId || null"
                [provider]="data.provider || 'gmail'"
                [ocrStatuses]="ocrStatuses()"
                (ocrPreviewRequest)="onOcrPreviewRequest(attachment.id, $event)"
                (onCloseOcrPreview)="onCloseOcrPreview(attachment.id)">
                <ng-template #checkboxTemplate>
                  <oiq-form-checkbox
                    class="p-1"
                    [formControl]="selectedFiles.at(i)"
                    orientation="right"
                    type="toggle">
                  </oiq-form-checkbox>
                </ng-template>
              </oiq-email-attachment>
            }
          </div>
        }

        <div class="flex items-center justify-end gap-2">
          <button class="oiq-button oiq-button--outline" (click)="cancel()">Cancel</button>
          <button
            class="oiq-button oiq-button--primary--solid"
            (click)="confirmLinkDocuments()"
            [disabled]="!hasSelectedFiles() || isLinkingDocuments()">
            Confirm & Link
          </button>
        </div>
      }

      @if (data.mode === 'stipulations') {
        <div class="flex flex-col gap-2">
          <div class="flex items-center gap-2">
            <svg
              width="13"
              height="15"
              viewBox="0 0 13 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.2105 2.97703L9.39797 0.164531C9.34569 0.112312 9.28364 0.0709042 9.21535 0.0426734C9.14707 0.0144426 9.07389 -5.79295e-05 9 1.73924e-07H3.375C3.07663 1.73924e-07 2.79048 0.118527 2.57951 0.329505C2.36853 0.540483 2.25 0.826632 2.25 1.125V2.25H1.125C0.826631 2.25 0.540483 2.36853 0.329505 2.57951C0.118526 2.79048 0 3.07663 0 3.375V13.5C0 13.7984 0.118526 14.0845 0.329505 14.2955C0.540483 14.5065 0.826631 14.625 1.125 14.625H9C9.29837 14.625 9.58452 14.5065 9.79549 14.2955C10.0065 14.0845 10.125 13.7984 10.125 13.5V12.375H11.25C11.5484 12.375 11.8345 12.2565 12.0455 12.0455C12.2565 11.8345 12.375 11.5484 12.375 11.25V3.375C12.3751 3.30111 12.3606 3.22793 12.3323 3.15965C12.3041 3.09136 12.2627 3.02931 12.2105 2.97703ZM9 13.5H1.125V3.375H6.51727L9 5.85773V11.8012C9 11.8055 9 11.809 9 11.8125C9 11.816 9 11.8195 9 11.8238V13.5ZM11.25 11.25H10.125V5.625C10.1251 5.55111 10.1106 5.47793 10.0823 5.40965C10.0541 5.34136 10.0127 5.27931 9.96047 5.22703L7.14797 2.41453C7.09569 2.36231 7.03364 2.3209 6.96535 2.29267C6.89707 2.26444 6.82389 2.24994 6.75 2.25H3.375V1.125H8.76727L11.25 3.60773V11.25ZM7.3125 9C7.3125 9.14918 7.25324 9.29226 7.14775 9.39775C7.04226 9.50324 6.89918 9.5625 6.75 9.5625H3.375C3.22582 9.5625 3.08274 9.50324 2.97725 9.39775C2.87176 9.29226 2.8125 9.14918 2.8125 9C2.8125 8.85082 2.87176 8.70774 2.97725 8.60225C3.08274 8.49676 3.22582 8.4375 3.375 8.4375H6.75C6.89918 8.4375 7.04226 8.49676 7.14775 8.60225C7.25324 8.70774 7.3125 8.85082 7.3125 9ZM7.3125 11.25C7.3125 11.3992 7.25324 11.5423 7.14775 11.6477C7.04226 11.7532 6.89918 11.8125 6.75 11.8125H3.375C3.22582 11.8125 3.08274 11.7532 2.97725 11.6477C2.87176 11.5423 2.8125 11.3992 2.8125 11.25C2.8125 11.1008 2.87176 10.9577 2.97725 10.8523C3.08274 10.7468 3.22582 10.6875 3.375 10.6875H6.75C6.89918 10.6875 7.04226 10.7468 7.14775 10.8523C7.25324 10.9577 7.3125 11.1008 7.3125 11.25Z"
                fill="#606B84" />
            </svg>
            <h2 class="text-[18px] font-medium">Select a Stipulation(s)</h2>
          </div>
          <p class="mb-4">Please select a stipulation for each attachment</p>

          @if (mappedAttachments().length > 0) {
            <div class="space-y-2">
              @for (attachment of mappedAttachments(); track attachment.id) {
                <oiq-email-attachment
                  [mode]="'attach'"
                  [pngPreviewMode]="'new-application'"
                  [(attachedStipulations)]="attachedStipulations"
                  [emailAttachment]="attachment"
                  [emailId]="attachment.emailId || data.emailId || null"
                  [provider]="data.provider || 'gmail'"
                  [ocrStatuses]="ocrStatuses()"
                  (ocrPreviewRequest)="onOcrPreviewRequest(attachment.id, $event)"
                  (onCloseOcrPreview)="onCloseOcrPreview(attachment.id)">
                </oiq-email-attachment>
              }
            </div>
          }

          <div class="flex items-center justify-end gap-2">
            <button class="oiq-button oiq-button--outline" (click)="cancel()">Cancel</button>
            <button
              class="oiq-button oiq-button--primary--solid"
              (click)="confirmAttachStipulations()"
              [disabled]="attachedStipulations().length === 0 || isSavingStipulations()">
              Confirm
            </button>
          </div>
        </div>
      }

      @if (data.mode === 'new-application') {
        <div class="flex flex-col gap-2">
          <div class="flex items-center gap-2">
            <svg
              width="13"
              height="15"
              viewBox="0 0 13 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.2105 2.97703L9.39797 0.164531C9.34569 0.112312 9.28364 0.0709042 9.21535 0.0426734C9.14707 0.0144426 9.07389 -5.79295e-05 9 1.73924e-07H3.375C3.07663 1.73924e-07 2.79048 0.118527 2.57951 0.329505C2.36853 0.540483 2.25 0.826632 2.25 1.125V2.25H1.125C0.826631 2.25 0.540483 2.36853 0.329505 2.57951C0.118526 2.79048 0 3.07663 0 3.375V13.5C0 13.7984 0.118526 14.0845 0.329505 14.2955C0.540483 14.5065 0.826631 14.625 1.125 14.625H9C9.29837 14.625 9.58452 14.5065 9.79549 14.2955C10.0065 14.0845 10.125 13.7984 10.125 13.5V12.375H11.25C11.5484 12.375 11.8345 12.2565 12.0455 12.0455C12.2565 11.8345 12.375 11.5484 12.375 11.25V3.375C12.3751 3.30111 12.3606 3.22793 12.3323 3.15965C12.3041 3.09136 12.2627 3.02931 12.2105 2.97703ZM9 13.5H1.125V3.375H6.51727L9 5.85773V11.8012C9 11.8055 9 11.809 9 11.8125C9 11.816 9 11.8195 9 11.8238V13.5ZM11.25 11.25H10.125V5.625C10.1251 5.55111 10.1106 5.47793 10.0823 5.40965C10.0541 5.34136 10.0127 5.27931 9.96047 5.22703L7.14797 2.41453C7.09569 2.36231 7.03364 2.3209 6.96535 2.29267C6.89707 2.26444 6.82389 2.24994 6.75 2.25H3.375V1.125H8.76727L11.25 3.60773V11.25ZM7.3125 9C7.3125 9.14918 7.25324 9.29226 7.14775 9.39775C7.04226 9.50324 6.89918 9.5625 6.75 9.5625H3.375C3.22582 9.5625 3.08274 9.50324 2.97725 9.39775C2.87176 9.29226 2.8125 9.14918 2.8125 9C2.8125 8.85082 2.87176 8.70774 2.97725 8.60225C3.08274 8.49676 3.22582 8.4375 3.375 8.4375H6.75C6.89918 8.4375 7.04226 8.49676 7.14775 8.60225C7.25324 8.70774 7.3125 8.85082 7.3125 9ZM7.3125 11.25C7.3125 11.3992 7.25324 11.5423 7.14775 11.6477C7.04226 11.7532 6.89918 11.8125 6.75 11.8125H3.375C3.22582 11.8125 3.08274 11.7532 2.97725 11.6477C2.87176 11.5423 2.8125 11.3992 2.8125 11.25C2.8125 11.1008 2.87176 10.9577 2.97725 10.8523C3.08274 10.7468 3.22582 10.6875 3.375 10.6875H6.75C6.89918 10.6875 7.04226 10.7468 7.14775 10.8523C7.25324 10.9577 7.3125 11.1008 7.3125 11.25Z"
                fill="#606B84" />
            </svg>

            <h2 class="text-[18px] font-medium">Select a Document(s)</h2>
          </div>
          <p class="mb-4">Please select a document for used in New Application</p>

          @if (mappedAttachments().length > 0) {
            <div class="flex flex-col">
              <div class="mb-2 flex items-center justify-between">
                <p class="text-sm font-medium text-gray-2">Email Attachment(s):</p>

                <div class="flex items-center gap-2">
                  <oiq-form-checkbox
                    class="p-1"
                    [formControl]="selectAllControl"
                    label="Select All"
                    orientation="right"
                    type="toggle">
                  </oiq-form-checkbox>
                </div>
              </div>
              @for (group of attachmentGroups(); track group.key) {
                @if (showAttachmentGroupLabels()) {
                  <p
                    class="mb-1 mt-2 text-xs font-medium text-gray-2"
                    [class]="!$first ? 'border-t border-dotted pt-4' : ''">
                    {{ group.label }}
                  </p>
                }
                @for (item of group.items; track item.attachment.id) {
                  <oiq-email-attachment
                    [displayMode]="'dialog'"
                    [pngPreviewMode]="'new-application'"
                    [(attachedStipulations)]="attachedStipulations"
                    [emailAttachment]="item.attachment"
                    [emailId]="item.attachment.emailId || data.emailId || null"
                    [provider]="data.provider || 'gmail'"
                    [ocrStatuses]="ocrStatuses()"
                    (ocrPreviewRequest)="onOcrPreviewRequest(item.attachment.id, $event)"
                    (onCloseOcrPreview)="onCloseOcrPreview(item.attachment.id)">
                    <ng-template #checkboxTemplate>
                      <oiq-form-checkbox
                        class="p-1"
                        [formControl]="selectedFiles.at(item.index)"
                        orientation="right"
                        type="toggle">
                      </oiq-form-checkbox>
                    </ng-template>
                  </oiq-email-attachment>
                }
              }
            </div>
          }

          <div class="flex items-center justify-end gap-2">
            <button class="oiq-button oiq-button--outline" (click)="cancel()">Cancel</button>
            <button
              class="oiq-button oiq-button--primary--solid"
              (click)="confirmNewApplication()"
              [disabled]="isCreatingApplication()">
              Confirm & Create Application
            </button>
          </div>
        </div>
      }
    </main>

    <!-- PNG Preview Column (shown on the right when preview is active) -->
    @if (showPngPreview() && selectedPngFiles().length > 0) {
      <div
        class="w-full min-w-[586px] max-w-[586px] flex-1 border-l border-gray-200 bg-gray-50 px-6 py-4">
        <oiq-email-png-preview
          [pngFiles]="selectedPngFiles()"
          [isVisible]="showPngPreview()"
          [mode]="'new-application'">
        </oiq-email-png-preview>
      </div>
    }
  </div>
</div>
